import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Button } from '@mui/material';
import { $notReadImports, importReadNotification } from '../../../model';
import { processStatuses } from '../../../types';
import * as Styled from './styled';

export const ResetReadImports = () => {
  const { t } = useTranslation();
  const [notReadImports] = useUnit([$notReadImports]);

  const handleClick = () => {
    importReadNotification(
      notReadImports
        .filter(({ status }) => status !== processStatuses.processing)
        .map(({ id }) => id)
    );
  };

  return (
    <Styled.ResetReadImports>
      <Button variant="text" size="small" onClick={handleClick}>
        {t('ClearCompleted')}
      </Button>
    </Styled.ResetReadImports>
  );
};
